import React from 'react';
import { ctaLink } from '../data/mock';
import { Sparkles, Twitter, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Product: [
      { name: 'Features', href: '#features' },
      { name: 'Pricing', href: '#pricing' },
      { name: 'How It Works', href: '#how-it-works' },
      { name: 'Blog Hosting', href: ctaLink }
    ],
    Resources: [
      { name: 'Blog', href: ctaLink },
      { name: 'Case Studies', href: ctaLink },
      { name: 'Documentation', href: ctaLink },
      { name: 'FAQ', href: '#faq' }
    ],
    Company: [
      { name: 'About', href: ctaLink },
      { name: 'Contact', href: ctaLink },
      { name: 'Privacy Policy', href: ctaLink },
      { name: 'Terms of Service', href: ctaLink }
    ]
  };

  const socialLinks = [
    { icon: Twitter, href: ctaLink, label: 'Twitter' },
    { icon: Linkedin, href: ctaLink, label: 'LinkedIn' },
    { icon: Mail, href: ctaLink, label: 'Email' }
  ];

  return (
    <footer className="relative border-t border-white/5">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-950" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[200px] bg-cyan-500/5 rounded-full blur-[100px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href={ctaLink} className="flex items-center gap-2 mb-6 group">
              <div className="relative">
                <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center shadow-lg shadow-cyan-500/30">
                  <Sparkles className="w-5 h-5 text-white" />
                </div>
              </div>
              <span className="text-xl font-bold text-white tracking-tight">
                outwrite<span className="text-cyan-400">.ai</span>
              </span>
            </a>
            <p className="text-slate-400 mb-6 max-w-sm leading-relaxed">
              Be the answer AI recommends. Create content that gets cited by ChatGPT, Claude, Gemini, and Perplexity.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-cyan-400 hover:border-cyan-500/30 hover:bg-cyan-500/10 transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('#') ? undefined : '_blank'}
                      rel={link.href.startsWith('#') ? undefined : 'noopener noreferrer'}
                      className="text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {currentYear} outwrite.ai. All rights reserved.
          </p>
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border border-cyan-500/20 rounded-full text-sm font-medium text-cyan-300 hover:bg-cyan-500/20 transition-all duration-300"
          >
            <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            Start Free Today
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
